<template lang="pug">
w-slider.w-seek-minimal(
  no-labels
  :max='seconds'
  :format='formatTime'
  :value='value'
  :size='size'
  @input='input'
)
</template>

<script lang="js">
import { Duration } from '@/util'
import WSlider from './w-slider'

export default {
  name: 'MinimalSeekWidget',
  mixins: [],
  components: { WSlider },
  props: {
    length: {
      type: [ String, Number, Object, Duration ],
      required: true
    },
    value: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: 'lg'
    },
  },
  data() {
    return {
      Duration,
    }
  },
  created() {},
  mounted() {},
  methods: {
    formatTime( seconds ) {
      return new Duration( seconds ).toString()
    },
    input( $event ) {
      this.$emit( 'input', $event )
    }
  },
  computed: {
    duration() {
      return this.length instanceof Duration ? this.length
         : new Duration( this.length )
    },
    seconds() { return this.duration.toSeconds() },
  }
}
</script>

<style lang="scss">
.w-seek-minimal {
  .bar {
    transition-duration: 50ms;
    box-shadow: var(--glow-hover);
  }
}
</style>
